<template>
    <div class="menu_cstm_section">
        <span class="menu_popup_close">
            <img src="../../../assets/images/menu/close.png" class="img-fluid" @click="menusPopupClosedMethod">
        </span>
        <div class="menu_cstm_container">
            <h2 class="menu_heading text-center">Discover our Expansive Ecosystem</h2>
			<p class="menu_subheading text-center">Visit our other sites and discover all the innovative paths <br> we are paving with Artifical Intelligence.</p>
            <div class="row">
                <div class="col-sm-3">
					<div class="menu_cstm_icon_box oddvega_box">
                        <a href="https://www.oddvega.com/" target="_blank">
                            <span class="menu_icon">
                                <img src="../../../assets/images/menu/oddvega-logo-new-curve.png" class="img-fluid"  width="70">
                            </span>
                            <span class="menu_txt">
                                Oddvega
                            </span>
                        </a>
                    </div>
                </div>
                <div class="col-sm-3">
					<div class="menu_cstm_icon_box oddboot_box">
                        <a href="https://oddboot.com/" target="_blank">
                            <span class="menu_icon">
                                <img src="../../../assets/images/menu/planet_hover.png" class="img-fluid">
                            </span>
                            <span class="menu_txt">
                                Oddboot
                            </span>
                        </a>
                    </div>
                </div>
                <div class="col-sm-3">
					<div class="menu_cstm_icon_box oddboot_ai_box">
                        <a href="https://ai.oddboot.com/" target="_blank">
                            <span class="menu_icon">
                                <img src="../../../assets/images/menu/ai_icon.png" class="img-fluid">
                            </span>
                            <span class="menu_txt">
                                Oddboot AI
                            </span>
                        </a>
                    </div>
                </div>
                <div class="col-sm-3">
					<div class="menu_cstm_icon_box oddboot_ai_box">
                        <a href="https://www.risklatte.ai/" target="_blank">
                            <span class="menu_icon">
                                <img src="../../../assets/images/menu/bell_curve.png" class="img-fluid">
                            </span>
                            <span class="menu_txt">
                                Risklatte AI
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/*eslint-disable */

import {bus} from '@/main';
export default {
  name: 'other-menus-list',
  methods: {
    menusPopupClosedMethod(){
     bus.$emit('menusListPopupBus', false);
     document.body.classList.remove('body_right_scroll_remove');
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../../../assets/fonts/origintech-personal-use-webfont/stylesheet.css';
.menu_cstm_section {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(4, 4, 4, 0.92);
    bottom: 0;
    z-index: 100;
    display:block !important;
}
.menu_cstm_section.active{display:block !important;}
.menu_cstm_container{padding:80px 40px 0;}
.menu_cstm_icon_box {
    background: rgba(24, 24, 24, 0.7);
    transition: all ease 0.5s;
    -webkit-transition: all ease 0.5s;
    -moz-transition: all ease 0.5s;
    border: 1px solid #2c2b2b;
    border-radius: 5px;
    text-align: center;
    padding:20px 35px;
    margin:15px 0;
    cursor: pointer;
    a{text-decoration:none;}
}
.menu_cstm_icon_box:hover{
    background: #ffffff;
    color:#000000;
}
.menu_cstm_icon_box:hover .menu_txt{color: #000000;}
.menu_cstm_icon_box span{display:block;}
.menu_txt {
    font-size: 22px;
    color: #fff;
    font-weight: 600;    
    padding-top: 30px;
    padding-bottom: 60px;
}
.menu_cstm_section  .menu_icon {
    line-height: 175px;
}
.menu_popup_close {
    position: absolute;
    right: 15px;
    top: 15px;
    width: 20px;
    cursor: pointer;
}
.menu_popup_close img:hover{
    filter: invert(90%) sepia(35%) saturate(3600%) hue-rotate(350deg) brightness(95%) contrast(80%);
}
.menu_heading{
    color: #d29e00;
    font-size: 40px;
    margin-bottom: 15px;
    padding: 0px;
    font-family: "origin_tech_demoregular";
    line-height: 1;
}
.menu_subheading {
    color: #bdbbb1;
    font-size: 18px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    margin-bottom: 25px;
}
.menu_cstm_icon_box.quizzort_box:hover .img-fluid{filter: invert(100%) sepia(15%) saturate(2400%) hue-rotate(140deg) brightness(100%) contrast(100%);}
.menu_cstm_icon_box.oddboot_ai_box:hover .img-fluid{filter: invert(100%) sepia(15%) saturate(2400%) hue-rotate(140deg) brightness(100%) contrast(100%);}
.menu_cstm_icon_box.oddboot_box:hover .img-fluid{filter: invert(60%) sepia(15%) saturate(2400%) hue-rotate(198deg) brightness(100%) contrast(100%);}
.menu_cstm_icon_box.oddvega_box:hover .img-fluid{filter: invert(25%) sepia(20%) saturate(2000%) hue-rotate(230deg) brightness(100%) contrast(100%);}
</style>